import * as React from 'react';

import {IconButton} from '../../../button/icon-button/icon-button';

import type {EventType} from '../../types';

import type {ToolbarOption} from './timeline-entry-toolbar';

export function getNounForEntryType(entryType: EventType): string {
    switch (entryType) {
        // Activities and meetings
        case 'Activity':
        case 'ZoomMeeting':
        case 'GoogleMeet':
        case 'MicrosoftTeams':
        case 'TeamsMeeting':
        case 'Aircall':
        case 'CallRail':
        case 'Dialpad':
        case 'RingCentral':
        case 'CallTrackerFX':
            return 'activity';

        // Notes and comments
        case 'Note':
            return 'note';
        case 'Comment':
            return 'comment';

        // Emails
        case 'Email':
        case 'EmailQueued':
        case 'AutomatedEmail':
        case 'AutomatedReply':
        case 'NutshellMarketingEmail':
        case 'FailedEmail':
            return 'email';

        // There are a lot more types that are not enumerated here, but they can't be deleted
        default:
            return 'entry';
    }
}

export function renderOptionForToolbar(option: ToolbarOption): React.ReactElement {
    // @ts-expect-error
    if (option.icon) {
        return (
            <IconButton
                key={option.id}
                // @ts-expect-error
                icon={option.icon}
                // @ts-expect-error
                onClick={option.onClick}
                // @ts-expect-error
                tooltipText={option.tooltipText}
                // @ts-expect-error
                isDisabled={option.isDisabled}
            />
        );
    }

    // The null case shouldn't ever happen, but flow is confused
    // @ts-expect-error
    return option.component ? (
        // @ts-expect-error
        <React.Fragment key={option.id}>{option.component}</React.Fragment>
    ) : // @ts-expect-error
    null;
}
